package model

import kotlinx.serialization.Serializable

@Serializable
data class StoresNearbyResponse(
    val nearbyStores: List<NearbyStore> = emptyList(),
)

@Serializable
data class NearbyStore(
    val id: Int,
    val storeName: String,
    val phoneNumber: String,
    val address: String,
    val offerId: Int? = null,
    val loyaltyProgramJoinMessage: String,
    val dailyOffer: DailyOffer? = null,
    val geoPoint: GeoPoint,
    val distanceMeters: Double,
)